import { ArrowRight } from "lucide-react";
import { useConsultation } from "@/context/ConsultationContext";
import { Reveal } from "@/components/Reveal";

// Reusable final CTA band.
export function CTABand({
  eyebrow = "Your future is waiting",
  title = "Start Your Portugal Journey",
  text = "From your first idea to building your future in Portugal — Effizent Europe is with you every step of the way.",
  interest,
}) {
  const { openConsultation } = useConsultation();
  return (
    <section data-testid="cta-band" className="relative bg-navy text-warm overflow-hidden">
      <div className="spotlight absolute inset-0 pointer-events-none" />
      <div className="max-w-4xl mx-auto px-6 py-28 md:py-36 text-center relative">
        <Reveal>
          <p className="accent-eyebrow text-gold">{eyebrow}</p>
          <h2 className="font-playfair text-4xl md:text-6xl mt-6 leading-tight">{title}</h2>
          <p className="text-warm/60 text-lg mt-6 max-w-2xl mx-auto leading-relaxed">{text}</p>
          <button
            data-testid="cta-band-button"
            onClick={() => openConsultation(interest)}
            className="group mt-10 inline-flex items-center gap-3 rounded-full bg-gold px-9 py-4 font-600 text-navy hover:bg-gold-soft transition-all hover:scale-105 active:scale-95"
          >
            Start Your Journey
            <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
